import { IApproveUserCriteria, IDenyUserCriteria, IDeleteUser, IFilterDTO, IRegisterUser, IReviewUserCriteria, IUserCriteria } from "../../types/types";
import { UserListType } from "./../../types/enums";
import { createFilterCriteria } from "../../utilities/filterCriteria";

export const getUserList = async (
	filter: IFilterDTO[],
	userListType: UserListType,
    includeInstitutionUsers: boolean = false
) => {
	
	let criteria = createFilterCriteria(filter) as IUserCriteria;
	criteria.approvedOnEndDate = criteria.approvedOnEndDate?.replace(
		"00:00:00.000Z",
		"23:59:59.000Z"
	);
	criteria.confirmedOnEndDate = criteria.confirmedOnEndDate?.replace(
		"00:00:00.000Z",
		"23:59:59.000Z"
	);
	criteria.includeInstitutionUsers = includeInstitutionUsers;

	let userList: IRegisterUser[] = [] as IRegisterUser[];

	if (userListType !== UserListType.all) {
		criteria.isConfirmed = true;

		switch (userListType) {
			case UserListType.approved:
				criteria.isApproved = true;
				break;
			case UserListType.unapproved:
				criteria.isApproved = false;
				break;
		}
	}

	try {

		let response = await fetch(`api/User/UserList`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(criteria),
		});

		if (!response.ok) {

			throw new Error("Failed to get user list.");

		}

		userList = await response.json();

	}

	catch (exception) {

		console.error(exception)
		throw exception;

	}

	return userList;
};

export const getApproveUserContent = async (registrationId: number) => {
	

	try {

		let response = await fetch(`api/Institution/GetMatchingInstitutionForRegistration/${registrationId}`);

		if (!response.ok) {

			throw new Error("Failed to get approve user content.");

		}

		return response.json();

	}

	catch (exception) {

		console.error(exception)
		throw exception;

	}

};

export const approveUser = async (criteria: IApproveUserCriteria) => {
	

	try {
		let response = await fetch(`api/User/ApproveUser/`, {
			method: "POST",
			headers: {
					"Content-Type": "application/json"
				},
			body: JSON.stringify(criteria),
		});

		if (!response.ok) {

			throw new Error("Failed to approve user.");

		}

		return response.json();

	}

	catch (exception) {

		console.error(exception)
		throw exception;

	}

};

export const denyUser = async (criteria: IDenyUserCriteria) => {
	

	try {

		let response = await fetch(`api/User/DenyUser/${criteria.userId}`);

		if (!response.ok) {

			throw new Error("Failed to deny user.");

		}

		return response.json();

	}

	catch (exception) {

		console.error(exception)
		throw exception;

	}

};

export const removeUserAccess = async (deleteUserInfo: IDeleteUser) => {
	try {
		

		let response = await fetch(`api/User/RemoveUserAccess/${deleteUserInfo.userId}/${deleteUserInfo.deletedByUserId}`);

		if (!response.ok)
			throw new Error(response.statusText);

		return response.json();
	} catch (error) {
		console.error(error);
		throw error;
	};
};

export const reviewUser = async (criteria: IReviewUserCriteria) => {
	

	try {

		let response = await fetch(`api/User/RegistrationDetail/${criteria.registrationId}`);

		if (!response.ok) {

			throw new Error("Failed to get registration detail.");

		}

		return response.json();

	}

	catch (exception) {

		console.error(exception)
		throw exception;

	}

};

export const updateUser = async (user: IRegisterUser) => {
	try {
		

		let response = await fetch(`api/User/ModifyUser/`, {
			method: 'POST',
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(user)
		});

		if (!response.ok)
			throw new Error(response.statusText);

		return response.json();
	} catch (error) {
		console.error(error);
		throw error;
	};
};

export const getAllRoles = async (isOnlyEpiqRoles: boolean) => {
	try {
		

		let response = await fetch(`api/Roles/GetRoles/${isOnlyEpiqRoles}`);

		if (!response.ok) {

			throw new Error("Failed to get all roles.");

		}

		return response.json();

	}

	catch (error) {

		console.error(error);
		throw error;

	};

}

export const  fetchUserByEmailAsync = async (userCriteria: IUserCriteria) => {

	try {
		let response = await fetch(`api/User/UserList`, {
			method: 'POST',
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(userCriteria),
		});

		if (!response.ok) {
			throw new Error("Failed to retrieve user by email...");
		}

		return await response.json();
	}
	catch (error) {
		console.error(error);
		throw error;
	};

}
